import { createFileRoute } from '@tanstack/react-router'
import { CONTACT_EMAIL, CONTACT_MAILTO_URL } from '@/lib/constants'
import { SITE_IMAGES } from '@/lib/site-images'
import { ContactForm } from '@/components/ContactForm'

export const Route = createFileRoute('/contact')({
  head: () => ({
    meta: [
      { title: 'Contact — Halo Compliance' },
      {
        name: 'description',
        content:
          'Schedule a demo or get in touch with the Halo Compliance team.',
      },
      { property: 'og:title', content: 'Contact — Halo Compliance' },
      { property: 'og:url', content: 'https://www.halocompliance.com/contact' },
    ],
    links: [{ rel: 'canonical', href: 'https://www.halocompliance.com/contact' }],
  }),
  component: ContactPage,
})

/** Dark wash + vignette so white title matches live banner and stays readable on busy scenes */
const contactHeroBg = `linear-gradient(
    to bottom,
    rgba(12, 12, 12, 0.45) 0%,
    rgba(12, 12, 12, 0.62) 45%,
    rgba(12, 12, 12, 0.78) 100%
  ),
  url("${SITE_IMAGES.contact.header}")`

function ContactPage() {
  return (
    <div className="marketing-inner marketing-contact-page">
      <section
        className="marketing-contact-hero-photo text-white d-flex align-items-center justify-content-center text-center"
        style={{ backgroundImage: contactHeroBg }}
      >
        <div className="container py-5 py-md-6">
          <h1 className="display-4 fw-normal font-serif mb-0 text-white">Contact Us</h1>
        </div>
      </section>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <p className="lead text-body-secondary text-center mb-4">
              Let Halo Compliance show you why sales, marketing and compliance professionals in the
              mortgage industry love our simple solution.
            </p>
            <p className="text-center mb-4">
              Fill out the form below or email us at:{' '}
              <a href={CONTACT_MAILTO_URL}>{CONTACT_EMAIL}</a>
            </p>
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  )
}
